import createComponent from '@carvana/merch-components/createComponent';

export const Content = createComponent('div', {
  className: 'flex flex-col gap-lg'
});

export const Description = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
